export const contest = {
    contestDetailsTabs : {
        learner: ['home', 'lessons', 'ranking'],
        default: ['home', 'lessons', 'manage', 'ranking']
    }
}